module.exports = __webpack_public_path__ + "img/40.ebcce607.jpg";